import { useEffect } from 'react';
import type { UiTheme } from '@/domain/types';

/** Reflect `settings.ui.theme` on the root element (`data-theme`), 'system' clears it. */
export function applyTheme(theme: UiTheme, root: HTMLElement = document.documentElement): void {
  if (theme === 'system') delete root.dataset.theme;
  else root.dataset.theme = theme;
}

export function useTheme(theme: UiTheme | undefined): void {
  useEffect(() => {
    if (theme) applyTheme(theme);
  }, [theme]);
}
